import React from "react"
import { isEmpty } from "lodash"
import "./_style.scss"

const Downloader = React.lazy(() =>
  import("§/src/components/sections/downloader")
)
const ButtonArrow = React.lazy(() =>
  import("§/src/components/atoms/buttons/button-arrow")
)
const ModalRight = React.lazy(() =>
  import("§/src/components/atoms/content/modal-right")
)
const FilterSelect = React.lazy(() =>
  import("§/src/components/atoms/filter/select")
)
const TileContentDownloads = React.lazy(() =>
  import("§/src/components/atoms/content/tile-content-downloads")
)

import CategoryBlock from "./category-block"

// Language
import { useTranslation } from "react-i18next"

const SibarModal = props => {
  const { t } = useTranslation()

  const resources = props.resources || []
  const currentResource = props.current || {}
  const domainUrl = props.domainUrl

  const compClassName = "downloader-with-modal"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  const filteredResourcesArr = resources?.filter(
    ({ category }) => category?.id !== currentResource?.category?.id
  )

  const sortedResourcesArr = !isEmpty(currentResource)
    ? [currentResource, ...filteredResourcesArr]
    : resources

  return (
    <div comp={compClassName} className={compClass}>
      <ModalRight modalid={props?.modalid}>
        <h4>
          <strong>{t("Documenti e manuali")}</strong>
        </h4>
        {sortedResourcesArr?.map((category, i) => (
          <CategoryBlock key={i} category={category} domainUrl={domainUrl} />
        ))}
        {/*
        <div className="d-flex flex-column gap-2">
          {resources.map((file, index) => (
            <div key={"download" + index}>
              <TileContentDownloads downloadsfiles={[file]} />
            </div>
          ))}
        </div>
        */}
      </ModalRight>
    </div>
  )
}

export default SibarModal
